var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},_vm._l((_vm.versions),function(item){return _c('div',{key:item.version,staticClass:"item"},[_c('h3',[_vm._v(_vm._s(item.version))]),_vm._v(" "),_vm._l((item.content),function(c,i){return _c('p',{key:'c'+i},[_vm._v("\n            "+_vm._s(c.item)+"\n        ")])})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6a2d5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VersionLog.vue
// module id = null
// module chunks = 